import styled from 'styled-components';
// import { LABEL } from 'src/common/base';
// import { DEFAULT_FONT_FAMILY } from 'src/common/constants';
// import { COLOR_PALETTE } from 'src/common/colors';

const DEFAULT_FONT_FAMILY = "Roboto";

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1;
    position: relative;
`;

export const InputContainer = styled.div`
    display: flex;
    flex-flow: column;
`;

export interface InputWrapperProps {
    padding?: string
    hasErrors?: boolean
    readOnly?: boolean
    flexFlow?: string
}
export const InputWrapper = styled.div`
    display: flex;
    flex-flow: ${(props: InputWrapperProps) => props.flexFlow ? props.flexFlow : 'column'};
    border-radius: 2px;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: ${(props: InputWrapperProps) => props.hasErrors ? '1px solid #fd583e' : '1px solid #b7c0d5'};
    height: 40px;
    justify-content: center;
    padding: ${(props: InputWrapperProps) => props.padding};
    &:focus-within {
        border-color: blue;
    };
    transition: all 0.250s;
    opacity: ${(props: InputWrapperProps) => props.readOnly ? '0.3' : '1'};
`

export const LabelContainer = styled.div`
    display: flex;
    flex-flow: row;
    padding: 8px 0px;
`;

// export const Label = styled(Label)`
//     font-family: ${DEFAULT_FONT_FAMILY};
//     font-size: 14px;
//     color: #373f53;
// `

export const ErrorContainer = styled.div`
    display: flex;
    position: absolute;
    left: 0;
    bottom: -4px;
    height: 10px;
`;



export const Label = styled.span`
    display: flex;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #f5f5f5;
`

export const ErrorText = styled(Label)`
    color: #fd583e;
    // font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: 0.6px;
`